import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchTohanMarcRegPageLoadResult,
  BatchTohanMarcRegPageLoadResultFromJSON
} from '@/api/models/batch/BatchTohanMarcRegPageLoadResult'
import {
  BatchTohanMarcRegRequest,
  BatchTohanMarcRegRequestToJSON
} from '@/api/models/batch/BatchTohanMarcRegRequest'

export class BatchTohanMarcRegApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTohanMarcRegPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTohanMarcRegPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createTohanMarcRegist(
    request: BatchTohanMarcRegRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/regist-tohan-marc`,
      BatchTohanMarcRegRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
